import CONFIG from "../config";

const DEFAULT_CONTENT_TYPE = 'application/json';

/**
 * @name mint
 * @function
 * @description Initiates the minting of a NFT
 * @param {object} body Request body
 * @returns {Promise}
 */
export const mint = ( body ) => request(  CONFIG.api + '/mint', DEFAULT_CONTENT_TYPE, body );

/**
 * @name moderate
 * @function
 * @description Checks image for explicit content
 * @param {blob} file 
 * @param {string} locale 
 * @returns {Promise}
 */
export const moderate = ( file, locale ) => {
    const body = new FormData();
    body.append( 'file', file );
    body.append( 'locale', locale );
    return request(  CONFIG.api + '/moderation', 'multipart/form-data', body );
}

/**
 * @name request
 * @function
 * @description Initiates a request
 * @param {string} url 
 * @param {object} body 
 * @param {string} [method='POST']
 * @returns {Promise}
 */
const request = ( url, contentType, body={}, method='POST' ) => {
    const headers = new Headers({ 'Content-Type': contentType }),
    options = {
        body,
        method,
        mode: 'cors'
    };

    if( contentType === DEFAULT_CONTENT_TYPE ){
        options.body = JSON.stringify( body );
        options.headers = headers;
    }

    return fetch( url, options ).then( res => res.json().then( data => ({ status: res.status, data, message: res.statusText }) ) );
}